<template lang="pug">

  v-dialog(v-model="showTermsModal" :width="'100%'" max-width="600px" :persistent="true")

    .dialogHeader

      .dialogHeaderTitle
        | Termos de uso

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close()")

    .dialogBody

      .dialogBodyContent

        terms-of-use

        .text-right
          sos-button(@buttonClick="close()" buttonLabel="Fechar" size="medium")

</template>

<script>

  import TermsOfUse from '@/components/TermsOfUse'
  import SosButton from '@/components/SosButton'

  export default {
    name: 'ModalTermsOfUse',

    components: {
      'terms-of-use': TermsOfUse,
      'sos-button': SosButton,
    },

    data: () => ({
      showTermsModal: false,
    }),

    methods: {
      //
      //
      //

      open () {
        this.showTermsModal = true
      },

      //
      //
      //

      close () {
        this.showTermsModal = false
      },
    },
  }

</script>
